import moment from 'moment';

export const useSimpleDate =
  () =>
  (dateString?: string): string =>
    dateString ? moment(dateString).format('DD/MM/YYYY hh:mm') : '';
